import React from "react";
import { FormControl } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import StringUtils from "../../../utils/StringUtils";
import "./InlineEditInputText.scss";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import InlineEditBase from "./InlineEditBase";
import withOnBlur from "react-onblur";
import useInlineEditInputEvents from "./useInlineEditInputEvents";
import InlineEditInputButtons from "./InlineEditInputButtons";

/**
 * Input box that display the value as read only until we click the Edit icon next to the label.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function InlineEditInputText(props) {
  return (
    <InlineEditBase
      {...props}
      EditComponent={WithOnBlurInputTextEditComponent}
    />
  );
}

// Add onBlur listeners on the whole edit component to detect when focus is not in any of its children anymore
const WithOnBlurInputTextEditComponent = withOnBlur()(InputTextEditComponent);

function InputTextEditComponent(props) {
  const {
    viewAs,
    placeholder,
    value,
    onSubmit,
    validate,
    onCancel,
    setBlurListener,
    unsetBlurListener,
  } = props;
  const focusRef = React.useRef();

  const formatOutput = React.useCallback((output) => {
    return StringUtils.nullToEmpty(output).trim();
  }, []);

  const { currentValue, submit, cancel, changeValue, validationError } =
    useInlineEditInputEvents(
      value,
      onSubmit,
      validate,
      onCancel,
      setBlurListener,
      unsetBlurListener,
      focusRef,
      null,
      formatOutput
    );

  const hasError = !StringUtils.isNullOrEmpty(validationError);

  // Submit button is clicked
  const onLocalSubmit = (event) => {
    event.preventDefault();
    submit();
  };

  // User types a letter in the input box
  const onChange = (event) => {
    changeValue(event.target.value);
    // Don't call validate here, because the current value might not be rendered yet.
  };

  // Cancel button is clicked
  const onClickCancel = (event) => {
    event.preventDefault();
    cancel();
  };

  return (
    <Form onSubmit={onLocalSubmit} className={"InputTextEditComponent"}>
      <Row className={"input-row"}>
        <Col className="input-col">
          <FormControl
            ref={focusRef}
            type="text"
            value={currentValue}
            onChange={onChange}
            placeholder={placeholder}
            size={viewAs === "h1" ? "lg" : "text"}
          />
        </Col>
      </Row>
      <Row>
        <Col className="validated-button-col">
          <InlineEditInputButtons
            size="sm"
            disabled={hasError}
            onClick={onClickCancel}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          {hasError && <div className={"error"}>{validationError}</div>}
        </Col>
      </Row>
    </Form>
  );
}
